import React,{ useState }from 'react';
import { useLayoutEffect, useRef } from "react";
import '../css/styles.css';
import logo_white from "../img/logo.png";
import Services from './Services';
import {Link} from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

export default function Header() {

  const div = useRef();

  useLayoutEffect(() => {
    const divAnimate = div.current.getBoundingClientRect().top;
    const onScroll = () => {
      if (divAnimate < window.scrollY) {
        div.current.style.top = 0;
        div.current.style.left = 0;
        div.current.style.boxShadow = " 0px 1px 10px #999";
        div.current.style.position = "sticky";
      } else {
        div.current.style.position = "relative";
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <>
    <head>
    <title>My Site: Contact Us</title>
    
    </head>
      <nav className="navbar sticky-top navbar-expand-lg bg-dark" style={{backgroundColor : "#13364a",boxShadow: "0px 0px 0px white"}} id="navbar" ref={div}>
        <div className="container">
          <a className="navbar-brand" href="/">
            <img src={logo_white} alt="" className="logo_image"/>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <i className="fas fa-bars"></i>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto w-100 justify-content-end">
              <li className="nav-item active"><Link className="nav-link" to="/">Home</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/aboutus">About Us</Link></li>
              
              <div className={`nav-item navbar-dropdown ${dropdownOpen ? 'open' : ''}`}>
                    <button className="dropdown-button nav-link" onClick={toggleDropdown}>
                      Services &nbsp;<FontAwesomeIcon icon={faCaretDown} /> 
                    </button>
                    {dropdownOpen && (
                        <div className="dropdown-content">
                          <Link className="nav-link" to="/services">CNC Laser Cutting Services</Link>
                          <Link className="nav-link" to="/services">CNC Bending Services</Link>
                          <Link className="nav-link" to="/services">Fabrication Services</Link>
                        </div>
                    )}
              </div>
              
              <li className="nav-item"><Link className="nav-link" to="/gallery">Gallery</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/patterndesign">Pattern Design</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/contact">Contact Us</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/contact">Get Quote</Link></li>
            </ul>
          </div>
        </div>
      </nav>


    </>
  )
}
